// src/pages/admin/EditTab.js
import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Breadcrumb } from "../../../components";
import { CardHeader } from "../../../components/cards";
import {Box} from "../../../components/elements";
import PageLayout from "../../../layouts/PageLayout";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { Button as MuiButton } from '@mui/material';
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";

export default function EditTab() {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [storehouses, setStorehouses] = useState([]);
  const [tab, setTab] = useState({
    storehouse: "",  // will hold the _id string
    index: "",
    name: ""
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 1️⃣ fetch all storehouses
    axios
      .get(`${process.env.REACT_APP_BASE_URL}common/storehouses`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(({ data }) => setStorehouses(data))
      .catch(console.error);

    // 2️⃣ fetch THIS tab and populate state
    axios
      .get(`${process.env.REACT_APP_BASE_URL}common/tabs/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(({ data }) => {
        setTab({
          // data.storehouse was populated as an object; we need its _id
          storehouse: typeof data.storehouse === "object"
            ? data.storehouse._id
            : data.storehouse,
          index: data.index,
          name: data.name,
        });
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [id]);

  const updateTab = async () => {
    const { storehouse, index, name } = tab;
    if (!storehouse || !index || !name) {
      alert("Storehouse, Index & Name are required.");
      return;
    }
    try {
      await axios.put(
        `${process.env.REACT_APP_BASE_URL}common/tabs/${id}`,
        tab,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert("Tab updated successfully!");
      navigate("/tab-list");
    } catch (e) {
      console.error(e);
      alert(e.response?.data?.message || "Error updating tab.");
    }
  };

  if (loading) {
    return (
      <PageLayout>
        <p>Loading…</p>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <Grid container spacing={2} className="align-items-center mb-3">
        <Grid size={{ xs: 12, md: 6 }}>
          <Breadcrumb title="Edit Tab" />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }} className="text-end">
          <Link to="/tab-list">
            <MuiButton variant="contained" color="secondary">Back to List</MuiButton>
          </Link>
        </Grid>
      </Grid>

      <Box className="mc-card">
        <Grid container spacing={2}>
          {/* Storehouse */}
          <Grid size={{ xs: 12 }} className="mb-3">
            <CardHeader title="Storehouse" />
            <TextField
              select
              fullWidth
              value={tab.storehouse}
              onChange={(e) =>
                setTab({ ...tab, storehouse: e.target.value })
              }
            >
              {storehouses.map((sh) => (
                <MenuItem key={sh._id} value={sh._id}>
                  {sh.code}
                  {sh.name && ` – ${sh.name}`}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          {/* Tab Index (now fully editable) */}
          <Grid size={{ xs: 12 }} className="mb-3">
            <CardHeader title="Tab Index" />
            <TextField
              type="number"
              fullWidth
              value={tab.index}
              onChange={(e) =>
                setTab({ ...tab, index: e.target.value })
              }
            />
          </Grid>

          {/* Tab Name */}
          <Grid size={{ xs: 12 }} className="mb-3">
            <CardHeader title="Tab Name" />
            <TextField
              fullWidth
              value={tab.name}
              onChange={(e) =>
                setTab({ ...tab, name: e.target.value })
              }
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} className="mt-3">
          <Grid size={{ xs: 12 }} className="text-end">
            <MuiButton variant="contained" color="primary" onClick={updateTab}>
              Save Changes
            </MuiButton>
          </Grid>
        </Grid>
      </Box>
    </PageLayout>
  );
}
